var render = function render(_c,_vm){return (_vm.props.value && _vm.props.value.symbol && _vm.props.value.color)?_c('v-icon',{staticClass:"tw-m-2",attrs:{"color":_vm.props.value.color}},[_vm._v(" mdi-"+_vm._s(_vm.props.value.symbol.symbol)+" ")]):_c('i',[_vm._v("-")])
}
var staticRenderFns = []

export { render, staticRenderFns }